/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

riot.mixin('cooldown', {
	init: function() {
		this.on('mount', function() {
			this._cooldowns = [];
		});

		this.isCoolingDown = function(id, time) {
			time = time || 1100;
			var cd = this._cooldowns[id];
			if (cd && window.performance.now() - cd < time) {
				return true;
			}
			this._cooldowns[id] = window.performance.now();
			return false;
		}.bind(this);
	}
});
